import { isMobile } from 'react-device-detect';
import { ContainerType } from '../types';
import { CURRENCIES } from './mock-data';
import { i18n } from '../i18n';

export const languageOptions = [
  { label: 'English', value: 'en', countryCode: 'US' },
  { label: 'Russian', value: 'ru', countryCode: 'RU' },
  { label: 'Chinese', value: 'cn', countryCode: 'CN' },
  { label: 'Turkish', value: 'tr', countryCode: 'TR' },
  { label: 'German', value: 'de', countryCode: 'DE' },
  { label: 'Arabic', value: 'ar', countryCode: 'SA' },
  { label: 'Vietnamese', value: 'vi', countryCode: 'VN' },
  { label: 'Indonesian', value: 'id', countryCode: 'ID' },
  { label: 'Spanish', value: 'es', countryCode: 'ES' },
  // { label: 'Portuguese', value: 'pt', countryCode: 'PT' },
  { label: 'French', value: 'fr', countryCode: 'FR' },
];

export const imageActions = [
  { label: i18n.t('dropdown.downloadImages'), value: 'download-images' },
  ...(isMobile ? [{ label: i18n.t('dropdown.shareImages'), value: 'share-images' }] : []),
];

export const documents = [
  { label: i18n.t('dropdown.hasDocument'), value: 'true' },
  { label: i18n.t('dropdown.hasNotDocument'), value: 'false' },
];

export const containerTypes: { label: string; value: ContainerType }[] = [
  { label: "20'DC", value: '20DC' },
  { label: "20'HC", value: '20HC' },
  { label: "20'RF", value: '20RF' },
  { label: "40'DC", value: '40DC' },
  { label: "40'HC", value: '40HC' },
  { label: "40'RF", value: '40RF' },
  { label: "40'OT", value: '40OT' },
  { label: "40'FR", value: '40FR' },
  { label: "45'HC", value: '45HC' },
];

export const containerConditionOptions = [
  { label: i18n.t('dropdown.NEW'), value: 'NEW' },
  { label: i18n.t('dropdown.CW'), value: 'CW' },
  { label: i18n.t('dropdown.IICL'), value: 'IICL' },
  { label: i18n.t('dropdown.WWT'), value: 'WWT' },
  { label: i18n.t('dropdown.AS_IS'), value: 'AS_IS' },
];

export const containerContents = [
  { label: i18n.t('dropdown.empty'), value: false },
  { label: i18n.t('dropdown.loaded'), value: true },
];

export const tiersOptions = [
  { label: '1', value: 1 },
  { label: '2', value: 2 },
  { label: '3', value: 3 },
  { label: '4', value: 4 },
  { label: '5', value: 5 },
  { label: '6', value: 6 },
  { label: '7', value: 7 },
  { label: '8', value: 8 },
  { label: '9', value: 9 },
  { label: '10', value: 10 },
  { label: '11', value: 11 },
  { label: '12', value: 12 },
  { label: '13', value: 13 },
  { label: '14', value: 14 },
  { label: '15', value: 15 },
  { label: '16', value: 16 },
  { label: '17', value: 17 },
  { label: '18', value: 18 },
  { label: '19', value: 19 },
  { label: '20', value: 20 },
];

export const optionalTiersOptions = [{ label: 'On Top', value: '' }, ...tiersOptions];

export const transportTypes = ['Ground', 'Rail', 'Port'];

export const companies = ['Maersk', 'CMA CGM'];

export const containerStatues = (canTrade: boolean) => [
  { label: i18n.t('common.gatedIn'), value: 'GATED_IN_NEW' },
  { label: i18n.t('dropdown.inDepot'), value: 'GATED_IN' },
  { label: i18n.t('common.gateOutRequested'), value: 'GATE_OUT_REQUESTED' },
  { label: i18n.t('common.gatedOut'), value: 'GATED_OUT' },
  ...(canTrade
    ? [
        { label: i18n.t('dropdown.notInMarket'), value: 'NOT_IN_MARKET' },
        { label: i18n.t('dropdown.forSale'), value: 'FOR_SALE' },
      ]
    : []),
  { label: i18n.t('dropdown.hold'), value: 'HOLD' },
];

export const gateInStatusOptions = [
  { label: i18n.t('dropdown.active'), value: 'ACTIVE' },
  { label: i18n.t('dropdown.expired'), value: 'EXPIRED' },
  { label: i18n.t('dropdown.completed'), value: 'COMPLETED' },
  { label: i18n.t('dropdown.deleted'), value: 'DELETED' },
];

export const gateOutStatusOptions = [
  { label: i18n.t('dropdown.active'), value: 'ACTIVE' },
  { label: i18n.t('dropdown.expired'), value: 'EXPIRED' },
  { label: i18n.t('dropdown.completed'), value: 'COMPLETED' },
];

export const roles = [
  { label: i18n.t('common.superAdmin'), value: 'SUPER_ADMIN' },
  { label: i18n.t('common.yardCompanyAdmin'), value: 'YARD_COMPANY_ADMIN' },
  { label: i18n.t('common.yardCompanyEmployee'), value: 'YARD_COMPANY_EMPLOYEE' },
  { label: i18n.t('common.yardCompanyViewer'), value: 'YARD_COMPANY_VIEWER' },
  { label: i18n.t('common.yardManager'), value: 'YARD_MANAGER' },
  { label: i18n.t('common.yardDispatcher'), value: 'YARD_DISPATCHER' },
  { label: i18n.t('common.clientManager'), value: 'CLIENT_MANAGER' },
  { label: i18n.t('common.clientDispatcher'), value: 'CLIENT_DISPATCHER' },
];

export const rolesV2 = [
  { label: i18n.t('common.superAdmin'), value: 'SuperAdmin' },
  { label: i18n.t('common.yardCompanyAdmin'), value: 'YardCompanyAdmin' },
  { label: i18n.t('common.yardCompanyEmployee'), value: 'YardCompanyEmployee' },
  { label: i18n.t('common.yardCompanyViewer'), value: 'YardCompanyViewer' },
  { label: i18n.t('common.yardManager'), value: 'YardManager' },
  { label: i18n.t('common.yardDispatcher'), value: 'YardDispatcher' },
  { label: i18n.t('common.clientManager'), value: 'ClientManager' },
  { label: i18n.t('common.clientDispatcher'), value: 'ClientDispatcher' },
];

export const recommendClientRoles = [
  { label: i18n.t('common.yardCompanyAdmin'), value: 'YARD_COMPANY_ADMIN' },
  { label: i18n.t('common.yardCompanyEmployee'), value: 'YARD_COMPANY_EMPLOYEE' },
  { label: i18n.t('common.yardCompanyViewer'), value: 'YARD_COMPANY_VIEWER' },
  { label: i18n.t('common.clientManager'), value: 'CLIENT_MANAGER' },
];

export const clientRoles = [
  { label: i18n.t('common.yardCompanyAdmin'), value: 'YARD_COMPANY_ADMIN' },
  { label: i18n.t('common.yardCompanyEmployee'), value: 'YARD_COMPANY_EMPLOYEE' },
  { label: i18n.t('common.yardCompanyViewer'), value: 'YARD_COMPANY_VIEWER' },
  { label: i18n.t('common.clientManager'), value: 'CLIENT_MANAGER' },
  { label: i18n.t('common.clientDispatcher'), value: 'CLIENT_DISPATCHER' },
];

export const tableDotsActions = [
  { label: i18n.t('dropdown.addImages'), value: 'addphotos' },
  { label: i18n.t('dropdown.addDocuments'), value: 'adddocuments' },
  { label: i18n.t('dropdown.delete'), value: 'delete' },
];

export const containersTableDotsSuperAdminActions = [
  { label: i18n.t('dropdown.addImages'), value: 'addphotos' },
  { label: i18n.t('dropdown.addDocuments'), value: 'adddocuments' },
  { label: i18n.t('dropdown.edit'), value: 'edit' },
  { label: i18n.t('dropdown.requestGateOut'), value: 'requestgateout' },
  { label: i18n.t('dropdown.transfer'), value: 'transfer' },
  { label: i18n.t('dropdown.markForSale'), value: 'sell' },
];

export const containersTableDotsAllActionsWithTransfer = [
  { label: i18n.t('dropdown.addImages'), value: 'addphotos' },
  { label: i18n.t('dropdown.addDocuments'), value: 'adddocuments' },
  { label: i18n.t('dropdown.edit'), value: 'edit' },
  { label: i18n.t('dropdown.requestGateOut'), value: 'requestgateout' },
  { label: i18n.t('dropdown.transfer'), value: 'transfer' },
];

export const containersTableDotsAllActions = [
  { label: i18n.t('dropdown.addImages'), value: 'addphotos' },
  { label: i18n.t('dropdown.addDocuments'), value: 'adddocuments' },
  { label: i18n.t('dropdown.edit'), value: 'edit' },
  { label: i18n.t('dropdown.requestGateOut'), value: 'requestgateout' },
];

export const containersTableDotsActions = [
  { label: i18n.t('dropdown.addImages'), value: 'addphotos' },
  { label: i18n.t('dropdown.addDocuments'), value: 'adddocuments' },
];

export const containersTableDotsClientActions = [
  { label: i18n.t('dropdown.requestGateOut'), value: 'requestgateout' },
  { label: i18n.t('dropdown.markForSale'), value: 'sell' },
];

export const gateAllTableDotsActions = [
  { label: i18n.t('dropdown.complete'), value: 'complete' },
  { label: i18n.t('dropdown.delete'), value: 'delete' },
  { label: i18n.t('dropdown.loaded'), value: 'loaded' },
];

export const gateTableDotsActions = [{ label: i18n.t('dropdown.complete'), value: 'complete' }];

export const repairStatusOptions = [
  { label: i18n.t('dropdown.draft'), value: 'DRAFT' },
  { label: i18n.t('dropdown.pending'), value: 'PENDING' },
  { label: i18n.t('dropdown.active'), value: 'ACTIVE' },
  { label: i18n.t('dropdown.rejected'), value: 'REJECTED' },
  { label: i18n.t('dropdown.completed'), value: 'COMPLETED' },
];

export const inventoryTableDotsActions = [
  { label: i18n.t('dropdown.finish'), value: 'complete' },
  { label: i18n.t('dropdown.edit'), value: 'edit' },
  { label: i18n.t('dropdown.delete'), value: 'delete' },
];

export const inventoryItemStatusOptions = [
  { label: i18n.t('dropdown.notFound'), value: 'NOT_FOUND' },
  { label: i18n.t('dropdown.extraFound'), value: 'EXTRA_FOUND' },
  { label: i18n.t('dropdown.dismatched'), value: 'DISMATCHED' },
  { label: i18n.t('dropdown.found'), value: 'FOUND' },
];

export const inventoryItemStatusSecondaryOptions = [
  { label: i18n.t('dropdown.dismatched'), value: 'DISMATCHED' },
  { label: i18n.t('dropdown.found'), value: 'FOUND' },
];

export const currencyOptions = Object.values(CURRENCIES).map((item) => ({
  label: `${item.code}: ${item.symbol}`,
  value: item.code,
}));

export const storagePricingActionMenuMissingOptions = [
  { label: i18n.t('dropdown.newPricing'), value: 'addPricing' },
];

export const storagePricingActionMenuOptions = [
  { label: i18n.t('dropdown.newPricing'), value: 'addPricing' },
  { label: i18n.t('dropdown.viewAndUpdatePricing'), value: 'viewPricing' },
];

export const storagePricingDotsViewActions = [
  { label: i18n.t('dropdown.viewPricing'), value: 'viewPricing' },
];

export const invoiceTypeOptions = [
  { label: i18n.t('dropdown.all'), value: 'ALL' },
  { label: i18n.t('dropdown.storage'), value: 'STORAGE' },
  { label: i18n.t('dropdown.crane'), value: 'CRANE' },
  { label: i18n.t('dropdown.other'), value: 'OTHER' },
];

export const lastVisitedAtOptions = [
  { label: i18n.t('dropdown.lastDayFc', { day: 1 }), value: 1 },
  { label: i18n.t('dropdown.lastDayFc', { day: 3 }), value: 3 },
  { label: i18n.t('dropdown.lastDayFc', { day: 7 }), value: 7 },
  { label: i18n.t('dropdown.lastDayFc', { day: 30 }), value: 30 },
];

export const managesalesTableDotsActions = [
  { label: i18n.t('dropdown.edit'), value: 'edit' },
  { label: i18n.t('dropdown.stopSelling'), value: 'delete' },
];

export const offersTableDotsSuperAdminActions = [
  { label: i18n.t('dropdown.markAsPaid'), value: 'mark-as-paid' },
  { label: i18n.t('dropdown.markAsUnpaid'), value: 'mark-as-unpaid' },
  { label: i18n.t('dropdown.markAsInstallment'), value: 'mark-as-installment' },
];

export const offersTableDotsClientSentAcceptedActions = [
  { label: i18n.t('dropdown.pay'), value: 'pay' },
  { label: i18n.t('dropdown.cancel'), value: 'cancel' },
];

export const offersTableDotsClientSentActions = [
  { label: i18n.t('dropdown.update'), value: 'update' },
  { label: i18n.t('dropdown.cancel'), value: 'cancel' },
];

export const offersTableDotsClientReceivedActions = [
  { label: i18n.t('dropdown.acceptOffer'), value: 'accept-offer' },
  { label: i18n.t('dropdown.rejectOffer'), value: 'reject-offer' },
];

export const salesStatusOptions = [
  { label: i18n.t('dropdown.forSale'), value: 'FOR_SALE' },
  { label: i18n.t('dropdown.awaitingPayment'), value: 'AWAITING_PAYMENT' },
  { label: i18n.t('dropdown.soldInstallment'), value: 'SOLD_INST' },
  { label: i18n.t('dropdown.sold'), value: 'SOLD' },
];

export const offerStatusOptions = (direction: 'received' | 'sent' = 'received') => [
  {
    label:
      direction === 'sent'
        ? i18n.t('dropdown.paymentRequired')
        : i18n.t('dropdown.awaitingPayment'),
    value: 'ACCEPTED',
  },
  { label: i18n.t('dropdown.paid'), value: 'CLOSED' },
  { label: i18n.t('dropdown.cancelled'), value: 'CANCELLED' },
];

export const offerDirectionOptions = [
  { label: i18n.t('dropdown.receivedOffers'), value: 'received' },
  { label: i18n.t('dropdown.sentOffers'), value: 'sent' },
];

export const listModeOptions = [{ label: i18n.t('dropdown.latest'), value: 'latest' }];

export const salesFeeActionMenuMissingOptions = [
  { label: i18n.t('dropdown.newCommission'), value: 'addFee' },
];

export const salesFeeActionMenuOptions = [
  { label: i18n.t('dropdown.newCommission'), value: 'addFee' },
  { label: i18n.t('dropdown.viewAndUpdateCommission'), value: 'viewFee' },
];

export const salesFeeDotsViewActions = [{ label: i18n.t('dropdown.viewFee'), value: 'viewFee' }];

export const clientCategories = [
  { label: i18n.t('dropdown.vendor'), value: 'VENDOR' },
  { label: i18n.t('dropdown.trader'), value: 'TRADER' },
  { label: i18n.t('dropdown.none'), value: 'NONE' },
];

export const clientCategoriesV2 = [
  { label: i18n.t('dropdown.logisticCompany'), value: 'Logistic Company' },
  { label: i18n.t('dropdown.containerDepot'), value: 'Container Depot (Terminal)' },
  { label: i18n.t('dropdown.containerTrader'), value: 'Container Trader' },
  { label: i18n.t('dropdown.other'), value: 'Other' },
];

export const gateOutAllowedOptions = [
  { label: i18n.t('dropdown.gateOutAutomatic'), value: true },
  { label: i18n.t('dropdown.gateOutDispatcherApprovalRequired'), value: false },
];

export const gateOutCreateModeOptions = [
  { label: i18n.t('dropdown.normal'), value: 'normal' },
  { label: i18n.t('dropdown.filter'), value: 'filter' },
];

export const messengerOptions = [
  {
    label: i18n.t('dropdown.telegram'),
    value: 'Telegram',
  },
  {
    label: i18n.t('dropdown.whatsApp'),
    value: 'WhatsApp',
  },
  {
    label: i18n.t('dropdown.weChat'),
    value: 'WeChat',
  },
  {
    label: i18n.t('dropdown.line'),
    value: 'Line',
  },
];

export const roleBasedCreateEmployeeOptions: any = {
  SUPER_ADMIN: {
    YardCompany: [
      { label: i18n.t('dropdown.admin'), value: 'Admin' },
      { label: i18n.t('dropdown.employee'), value: 'Employee' },
      { label: i18n.t('dropdown.viewer'), value: 'Viewer' },
    ],
    Yard: [
      { label: i18n.t('dropdown.manager'), value: 'Manager' },
      { label: i18n.t('dropdown.dispatcher'), value: 'Dispatcher' },
      { label: i18n.t('dropdown.craneOperator'), value: 'CraneOperator' },
    ],
    Client: [
      { label: i18n.t('dropdown.manager'), value: 'Manager' },
      { label: i18n.t('dropdown.dispatcher'), value: 'Dispatcher' },
    ],
  },
  YARD_COMPANY_ADMIN: {
    YardCompany: [
      { label: i18n.t('dropdown.employee'), value: 'Employee' },
      { label: i18n.t('dropdown.viewer'), value: 'Viewer' },
    ],
    Yard: [
      { label: i18n.t('dropdown.manager'), value: 'Manager' },
      { label: i18n.t('dropdown.dispatcher'), value: 'Dispatcher' },
      { label: i18n.t('dropdown.craneOperator'), value: 'CraneOperator' },
    ],
    Client: [{ label: i18n.t('dropdown.manager'), value: 'Manager' }],
  },
  YARD_MANAGER: {
    Yard: [
      { label: i18n.t('dropdown.dispatcher'), value: 'Dispatcher' },
      { label: i18n.t('dropdown.craneOperator'), value: 'CraneOperator' },
    ],
    Client: [{ label: i18n.t('dropdown.manager'), value: 'Manager' }],
  },
  YARD_DISPATCHER: {
    Client: [{ label: i18n.t('dropdown.manager'), value: 'Manager' }],
  },
  CLIENT_MANAGER: {
    Client: [{ label: i18n.t('dropdown.dispatcher'), value: 'Dispatcher' }],
  },
};

export const employeesRolesFilterOptions: any = {
  SUPER_ADMIN: [
    { label: i18n.t('common.yardCompanyAdmin'), value: 'YARD_COMPANY_ADMIN' },
    { label: i18n.t('common.yardCompanyEmployee'), value: 'YARD_COMPANY_EMPLOYEE' },
    { label: i18n.t('common.yardCompanyViewer'), value: 'YARD_COMPANY_VIEWER' },
    { label: i18n.t('common.yardManager'), value: 'YARD_MANAGER' },
    { label: i18n.t('common.yardDispatcher'), value: 'YARD_DISPATCHER' },
    { label: i18n.t('common.clientManager'), value: 'CLIENT_MANAGER' },
    { label: i18n.t('common.clientDispatcher'), value: 'CLIENT_DISPATCHER' },
  ],
  YARD_COMPANY_ADMIN: [
    { label: i18n.t('common.yardCompanyEmployee'), value: 'YARD_COMPANY_EMPLOYEE' },
    { label: i18n.t('common.yardCompanyViewer'), value: 'YARD_COMPANY_VIEWER' },
    { label: i18n.t('common.yardManager'), value: 'YARD_MANAGER' },
    { label: i18n.t('common.yardDispatcher'), value: 'YARD_DISPATCHER' },
  ],
  YARD_MANAGER: [{ label: i18n.t('common.yardDispatcher'), value: 'YARD_DISPATCHER' }],
  CLIENT_MANAGER: [{ label: i18n.t('common.clientDispatcher'), value: 'CLIENT_DISPATCHER' }],
};

export const employeesFormCompanyRolesOptions: any = {
  SUPER_ADMIN: [
    { label: i18n.t('common.yardCompany'), value: 'YardCompany' },
    { label: i18n.t('common.yard'), value: 'Yard' },
    { label: i18n.t('common.client'), value: 'Client' },
  ],
  YARD_COMPANY_ADMIN: [
    { label: i18n.t('common.yardCompany'), value: 'YardCompany' },
    { label: i18n.t('common.yard'), value: 'Yard' },
    { label: i18n.t('common.client'), value: 'Client' },
  ],
  YARD_COMPANY_VIEWER: [
    { label: i18n.t('common.yardCompany'), value: 'YardCompany' },
    { label: i18n.t('common.yard'), value: 'Yard' },
    { label: i18n.t('common.client'), value: 'Client' },
  ],
  YARD_MANAGER: [
    { label: i18n.t('common.yard'), value: 'Yard' },
    { label: i18n.t('common.client'), value: 'Client' },
  ],
  YARD_DISPATCHER: [{ label: i18n.t('common.client'), value: 'Client' }],
  CLIENT_MANAGER: [{ label: i18n.t('common.client'), value: 'Client' }],
};

export const employeetableDotsActions = [
  { label: i18n.t('dropdown.activate'), value: 'ACTIVATE' },
  { label: i18n.t('dropdown.deactivate'), value: 'DEACTIVATE' },
];

export const employeesAccountStatus = [
  { label: i18n.t('dropdown.ACTIVE'), value: 'ACTIVE' },
  { label: i18n.t('dropdown.DEACTIVATED'), value: 'DEACTIVATED' },
];

export const employeesThreeDots: any = {
  ACTIVE: [{ label: i18n.t('dropdown.DEACTIVATE'), value: 'DEACTIVATE' }],
  DEACTIVATED: [{ label: i18n.t('dropdown.ACTIVATE'), value: 'ACTIVATE' }],
};

export const employeesCanCreateClientOptions = [
  { label: i18n.t('dropdown.ACTIVATE'), value: true },
  { label: i18n.t('dropdown.DEACTIVATE'), value: false },
];

export const canTradeOptions = [
  { label: i18n.t('common.yes'), value: true },
  { label: i18n.t('common.no'), value: false },
];

export const invoiceCreateModeOptions = [
  { label: i18n.t('dropdown.auto'), value: 'AUTO' },
  { label: i18n.t('dropdown.manual'), value: 'MANUAL' },
];
